import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "./../../store/actions/ahorroYCredito.actions";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
//import Routes from "app/@Routes/Routes";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import './FirmaDigital.css';

const root = process.env.REACT_APP_CMS_STATIC;

function FirmaDigital(props) {
  const dispatch = useDispatch();

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  

  const { firmaDigital } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );  
  
  useEffect(() => {
    dispatch(CMSActions.getFirmaDigital());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defRoute = rutas?.filter((route) => route?.name === "FirmaDigital");

 

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />      
      {firmaDigital && <>
        <TextoYTitulo            
            title={firmaDigital.aCFirmaDigital[0]?.titulo?.html.toString()}
            text={firmaDigital.aCFirmaDigital[0]?.descripcion?.html.toString()}
            borderTopColor="#D7DE00"
        />
        <div className="d-flex justify-content-start ps-5 pb-4">
          <a href={firmaDigital.aCFirmaDigital[0]?.urlAC.url} target="_blank" rel="noreferrer">
            <img src={root+firmaDigital.aCFirmaDigital[0]?.boton?.urls[0]} alt={firmaDigital.aCFirmaDigital[0]?.titulo}/>
          </a>
        </div>
        </>
      }
    </>
  );
}

export default FirmaDigital;
